<template>
  <div v-if="!getIsLoadedState" class="loading-screen">
    <span>...loading</span>
  </div>
</template>

<script>
import { keyHandler, KEYS } from '@/mixins/keyHandler';

export default {
  mixins: [keyHandler],
  components: {},
  data() {
    return {
      keyStore: [],
      keyStoreTimer: 3000,
      keyStoreInterval: undefined,
    };
  },
  methods: {
    keyStoreHandler() {
      this.keyStoreInterval = setInterval(() => {
        if (this.keyStoreTimer <= 0) {
          this.keyStore = [];
          clearInterval(this.keyStoreInterval);
          return;
        }
        this.keyStoreTimer -= 1000;
      }, 1000);
    },
    eventHandler(key, event) {
      this.$store.dispatch('notification/new', {
        title: key,
        message: JSON.stringify(event),
      });
      switch (key) {
        case KEYS.KEY_2:
        case KEYS.KEY_0:
        case KEYS.KEY_1:
        case KEYS.KEY_5:
        case KEYS.KEY_3:
          // this.$store.dispatch('notification/new', { title: key });
          this.keyStore.push(key);
          break;
      }
    },
  },
  computed: {
    getIsLoadedState() {
      return this.$store.state.isLoadedState;
    },
  },
  watch: {
    keyStore(value) {
      console.log('WATCH keyStore,', value);
      if (value.join('') === '220') {
        this.$store.dispatch('device/reboot');
      }
      if (value.join('') === '225') {
        // Wie in Home.vue: 220 startet das GERAET neu, 225 nur die SEITE. Das
        // nicht standardisierte Argument von reload(true) ist weg - dieselbe
        // Angleichung wie dort, damit die beiden Kopien dieser Tastenfolge
        // nicht auseinanderlaufen.
        //this.$store.dispatch('device/reboot');
        location.reload();
      }
      if (value.length > 0) {
        if (this.keyStoreInterval) {
          this.keyStoreTimer = 3000;
        } else {
          this.keyStoreHandler();
        }
      }
      // this.$store.dispatch('notification/new', {
      //   title: 'KeyStore',
      //   message: this.keyStore,
      // });
    },
  },
  // created: function() {}
};
</script>

<style scoped>
.loading-screen {
  background: white;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100vh;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Loading.vue